import SideControlsPage from "Layouts/SideControls/SideControlsPage";
import React from "react";
import { useParams } from "react-router-dom";
import { AuthStore } from "stores/AuthStore";
import { useStore } from "utils/useStore";
import OrganizationDetail from "./OrganizationDetail";
import OrganizationDetailNavigation from "./OrganizationDetailNavigation";
import OrganizationDetailRoutes from "./OrganizationDetailRoutes";

const OrganizationDetailContainer = () => {
    const { organizationId: routeOrganizationId } = useParams();
    const authStore = useStore(AuthStore);

    if (routeOrganizationId === "add") {
        return <OrganizationDetail />;
    }

    const organizationId =
        routeOrganizationId ??
        authStore.orgStore.selectedOrganization?.id ??
        authStore._user.profile.OrgId;

    return (
        <SideControlsPage
            mainContent={
                <OrganizationDetailRoutes organizationId={organizationId!} />
            }
            enableMinimize
            containerOffsetPixels={64}
            drawerContent={
                <OrganizationDetailNavigation
                    organizationId={organizationId!}
                />
            }
            drawerLocation="left"
            mainGridAlignItems="stretch"
            mainGridSpacing={0}
            mainSx={{
                padding: 0
            }}
        />
    );
};

export default OrganizationDetailContainer;
